import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { Carrier, RequireMatch, sortCarriers } from '../../../core';
import { CarrierService } from '../../../maintenance/services';
import { takeUntil, startWith, map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-carrier-autocomplete',
  templateUrl: './carrier-autocomplete.component.html'
})
export class CarrierAutocompleteComponent implements OnInit {
  @Input() placeholder: string = "Seleccione carrier";
  @Input() showHeader: boolean = true;
  @Output() onSelectCarrier = new EventEmitter<any>();
  @Output() onResetCarrier = new EventEmitter<boolean>();
  @Output() entitiesListed = new EventEmitter<boolean>();
  @Input() carrierIdInComming: number;
  carrierList: Carrier[] = [];
  listCarrierAutocomplet: Observable<any[]>;
  private onDestroy$: Subject<void> = new Subject<void>();
  carrier: FormControl;
  constructor(private carrierService: CarrierService) {
  }

  ngOnInit() {
    if(!this.carrier) { 
       this.carrier = new FormControl();
    }
    this.carrier.setValidators(RequireMatch);
    this.getCarriers(this.carrierIdInComming);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['carrierIdInComming'] && changes['carrierIdInComming'].firstChange && changes['carrierIdInComming'].currentValue !== changes['carrierIdInComming'].previousValue) {
      this.carrier = new FormControl();
      this.getCarriers(changes['carrierIdInComming'].currentValue);
    }
  }
  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  getCarriers(idCarrier?: number) {
    if (this.carrierList.length === 0) {
      this.carrierService.getListCarriers()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          response => {
            this.carrierList = sortCarriers(response);
            this.showCarrier();
            if (idCarrier) {
              const carrierSelected = this.carrierList.find(carrier => carrier.id === idCarrier);
              this.carrier.setValue(carrierSelected);
            }
            this.entitiesListed.emit(true);
          }
        );
    } else { 
      if (idCarrier) {
        const carrierSelected = this.carrierList.find(carrier => carrier.id === idCarrier);
        this.carrier.setValue(carrierSelected);
        this.changeSelectCarrier();
      }
    }
  }

  displayFnCarrier(carrier): string {
    return carrier ? (carrier.businessName ? carrier.businessName : carrier) : null;
  }

  showCarrier() {
    this.listCarrierAutocomplet = this.carrier.valueChanges.pipe(
      startWith(""),
      map((value) =>
        !value || typeof value === "string" ? value : value.businessName
      ),
      map((value) =>
        value ? this.filterCarrier(value) : this.carrierList.slice()
      )
    );
  }

  filterCarrier(value) {
    const filterValue = value.toLowerCase();
    return this.carrierList.filter(
      (item) =>
        item.businessName.toString().toLowerCase().indexOf(filterValue) >= 0
    );
  }

  cleanCarrier() {
    if (this.carrier) {
      this.carrier.setValue(null);
    }
    this.onResetCarrier.emit(true);
  }

  changeSelectCarrier() {
    this.onSelectCarrier.emit(this.carrier.value.id);
  }

  setCarrier(carrierId: number) {
    const carrierSelected = this.carrierList.find(carrier => carrier.id === carrierId);
    if (carrierSelected) {
      this.carrier.setValue(carrierSelected);
      this.changeSelectCarrier();
    }
  } 

  validateEditCarrier() {
    if (!(this.carrier.value && this.carrier.value.id)) {
      this.onResetCarrier.emit(true);
    }
  }
}
